import React from 'react';
import { NavLink } from 'react-router-dom';
import './AppNavigation.css';

const PRIMARY_ITEMS = [
    { to: '/workflow', label: 'Heute', shortLabel: 'Heute', hint: 'Tagessteuerung', symbol: 'H' },
    { to: '/projects', label: 'Mandate', shortLabel: 'Mandate', hint: 'Förderfälle', symbol: 'M' },
    { to: '/crm', label: 'Kunden', shortLabel: 'Kunden', hint: 'Beziehungsakten', symbol: 'K' },
    { to: '/revenue', label: 'Umsatz', shortLabel: 'Umsatz', hint: 'Chancen & Pipeline', symbol: 'U' },
    { to: '/finance', label: 'Finanzen', shortLabel: 'Finanzen', hint: 'Provision & Zahlungen', symbol: 'F' }
];

const SYSTEM_ITEMS = [
    { to: '/funding-database', label: 'Förderdatenbank' },
    { to: '/offer-templates', label: 'Angebotsvorlagen' },
    { to: '/ai-configuration', label: 'KI-Konfiguration' },
    { to: '/schema-health', label: 'Systemcheck' }
];

const getLinkClassName = ({ isActive }) => isActive ? 'app-navigation-link app-navigation-link-active' : 'app-navigation-link';

const AppNavigation = ({ compact = false, onNavigate = null }) => (
    <>
        <nav className={compact ? 'app-navigation app-navigation-compact' : 'app-navigation'} aria-label="Hauptnavigation">
            {PRIMARY_ITEMS.map((item) => (
                <NavLink key={item.to} to={item.to} className={getLinkClassName} onClick={onNavigate}>
                    <span className="app-navigation-symbol" aria-hidden="true">{item.symbol}</span>
                    <span className="app-navigation-copy">
                        <strong>{item.label}</strong>
                        {!compact && <small>{item.hint}</small>}
                    </span>
                </NavLink>
            ))}
        </nav>

        {!compact && (
            <details className="app-navigation-system">
                <summary>
                    <span className="app-navigation-symbol" aria-hidden="true">S</span>
                    <span>
                        <strong>System & Wissen</strong>
                        <small>Programme, KI und Technik</small>
                    </span>
                </summary>
                <nav aria-label="System und Wissen">
                    {SYSTEM_ITEMS.map((item) => (
                        <NavLink key={item.to} to={item.to} className={getLinkClassName} onClick={onNavigate}>
                            {item.label}
                        </NavLink>
                    ))}
                </nav>
            </details>
        )}
    </>
);

export { PRIMARY_ITEMS, SYSTEM_ITEMS };
export default AppNavigation;
